// GENERATED from pysrc/templates/*.py - ready-made indicators and strategies for the Python editor.
// Strategy results are a learning tool, not advice: no fees, no slippage, past results do not predict the future.
export const PYTHON_TEMPLATES = [
  {
    id: "i00_blank",
    name: "Start from blank (build your own)",
    kind: "indicator",
    description: "Commented scaffold: calculate, plot, mark",
    code: String.raw`# Build your own indicator - start here. Press Run to see the example line, then change it.
#
# What you have:
#   candles          list of candles: {"time", "open", "high", "low", "close", "volume"}  (press "Load candles" first)
#   df               a pandas table made from candles (first lines below)
# What you can draw:
#   plot("name", values)                         line on the price chart (one number per candle)
#   plot("name", values, pane="oscillator")      line in a separate pane below (for RSI-like indicators)
#   signals(entries, exits)                      arrows where a True/False Series is True
# Tip: ask Claude on the right, e.g. "build an indicator that shows when volume is 2x its average".
import pandas as pd

PERIOD = 20     # <- the number your indicator uses; change it and press Run again

df = pd.DataFrame(candles)

# 1) calculate your values (one per candle). Example: average of the last PERIOD closes
my_line = df["close"].rolling(PERIOD).mean()

# 2) draw them
plot("My indicator", my_line, color="#e3c46a")

# 3) (optional) mark candles with arrows: here, where the close crosses above my line
crossed_up = (df["close"] > my_line) & (df["close"].shift(1) <= my_line.shift(1))
signals(entries=crossed_up)
`,
  },
  {
    id: "i01_sma_ema",
    name: "Moving averages (SMA + EMA)",
    kind: "indicator",
    description: "Two moving averages on the price chart",
    code: String.raw`# Indicator: Moving averages (SMA + EMA), drawn on the price chart
import pandas as pd

FAST = 20     # <- change these numbers
SLOW = 50

df = pd.DataFrame(candles)
plot("SMA %d" % FAST, df["close"].rolling(FAST).mean(), color="#e3c46a")
plot("EMA %d" % SLOW, df["close"].ewm(span=SLOW, adjust=False).mean(), color="#a497e6")
print("Last close %.5f | SMA %d %.5f | EMA %d %.5f" % (
    df["close"].iloc[-1], FAST, df["close"].rolling(FAST).mean().iloc[-1], SLOW, df["close"].ewm(span=SLOW, adjust=False).mean().iloc[-1]))
`,
  },
  {
    id: "i02_bollinger",
    name: "Bollinger Bands",
    kind: "indicator",
    description: "Middle line and two bands",
    code: String.raw`# Indicator: Bollinger Bands (middle line = SMA, bands = +/- N standard deviations)
import pandas as pd

PERIOD = 20
WIDTH = 2.0   # number of standard deviations

df = pd.DataFrame(candles)
mid = df["close"].rolling(PERIOD).mean()
std = df["close"].rolling(PERIOD).std()
plot("BB middle", mid, color="#7d8aa0")
plot("BB upper", mid + WIDTH * std, color="#e3c46a")
plot("BB lower", mid - WIDTH * std, color="#e3c46a")
`,
  },
  {
    id: "i03_rsi",
    name: "RSI",
    kind: "indicator",
    description: "Momentum 0-100 with 70/30 lines",
    code: String.raw`# Indicator: RSI (Wilder), shown in its own pane with the 70 / 30 lines
import pandas as pd

PERIOD = 14

df = pd.DataFrame(candles)
change = df["close"].diff()
gain = change.clip(lower=0).ewm(alpha=1 / PERIOD, adjust=False).mean()
loss = (-change.clip(upper=0)).ewm(alpha=1 / PERIOD, adjust=False).mean()
rsi = 100 - 100 / (1 + gain / loss)

plot("RSI %d" % PERIOD, rsi, pane="oscillator", color="#6fbfb3")
plot("70", [70] * len(df), pane="oscillator", color="#db8352")
plot("30", [30] * len(df), pane="oscillator", color="#4f94db")
print("RSI now: %.1f" % rsi.iloc[-1])
`,
  },
  {
    id: "i04_macd",
    name: "MACD",
    kind: "indicator",
    description: "MACD, signal line and histogram",
    code: String.raw`# Indicator: MACD (fast EMA - slow EMA), its signal line and histogram, in a separate pane
import pandas as pd

FAST, SLOW, SIGNAL = 12, 26, 9

df = pd.DataFrame(candles)
macd = df["close"].ewm(span=FAST, adjust=False).mean() - df["close"].ewm(span=SLOW, adjust=False).mean()
signal_line = macd.ewm(span=SIGNAL, adjust=False).mean()

plot("MACD", macd, pane="oscillator", color="#e3c46a")
plot("Signal", signal_line, pane="oscillator", color="#a497e6")
plot("Histogram", macd - signal_line, pane="oscillator", color="#5d6a80")
`,
  },
  {
    id: "i05_atr",
    name: "ATR",
    kind: "indicator",
    description: "Average candle range (volatility)",
    code: String.raw`# Indicator: ATR (average true range) = how far price typically moves per candle
import pandas as pd

PERIOD = 14

df = pd.DataFrame(candles)
prev_close = df["close"].shift(1)
true_range = pd.concat([df["high"] - df["low"], (df["high"] - prev_close).abs(), (df["low"] - prev_close).abs()], axis=1).max(axis=1)
atr = true_range.ewm(alpha=1 / PERIOD, adjust=False).mean()

plot("ATR %d" % PERIOD, atr, pane="oscillator", color="#c98aa6")
print("ATR now: %.5f  (%.3f %% of price)" % (atr.iloc[-1], atr.iloc[-1] / df["close"].iloc[-1] * 100))
`,
  },
  {
    id: "i06_stochastic",
    name: "Stochastic",
    kind: "indicator",
    description: "%K / %D with 80/20 lines",
    code: String.raw`# Indicator: Stochastic oscillator (%K and %D) with the 80 / 20 lines
import pandas as pd

K_PERIOD, D_PERIOD = 14, 3

df = pd.DataFrame(candles)
low_min = df["low"].rolling(K_PERIOD).min()
high_max = df["high"].rolling(K_PERIOD).max()
k = 100 * (df["close"] - low_min) / (high_max - low_min)
d = k.rolling(D_PERIOD).mean()

plot("%K", k, pane="oscillator", color="#e3c46a")
plot("%D", d, pane="oscillator", color="#a497e6")
plot("80", [80] * len(df), pane="oscillator", color="#db8352")
plot("20", [20] * len(df), pane="oscillator", color="#4f94db")
`,
  },
  {
    id: "i07_donchian",
    name: "Donchian channel",
    kind: "indicator",
    description: "Highest high / lowest low",
    code: String.raw`# Indicator: Donchian channel (highest high / lowest low of the last N candles)
import pandas as pd

PERIOD = 20

df = pd.DataFrame(candles)
upper = df["high"].rolling(PERIOD).max()
lower = df["low"].rolling(PERIOD).min()
plot("Donchian high", upper, color="#4f94db")
plot("Donchian low", lower, color="#db8352")
plot("Donchian middle", (upper + lower) / 2, color="#7d8aa0")
`,
  },
  {
    id: "i08_supertrend",
    name: "Supertrend",
    kind: "indicator",
    description: "ATR trend line, green up / red down",
    code: String.raw`# Indicator: Supertrend (trend-following line built from ATR). Green = up trend, red = down trend.
import pandas as pd

PERIOD = 10
MULTIPLIER = 3.0

df = pd.DataFrame(candles)
prev_close = df["close"].shift(1)
true_range = pd.concat([df["high"] - df["low"], (df["high"] - prev_close).abs(), (df["low"] - prev_close).abs()], axis=1).max(axis=1)
atr = true_range.ewm(alpha=1 / PERIOD, adjust=False).mean()
mid = (df["high"] + df["low"]) / 2
upper_basic = (mid + MULTIPLIER * atr).tolist()
lower_basic = (mid - MULTIPLIER * atr).tolist()
close = df["close"].tolist()

upper, lower, trend = list(upper_basic), list(lower_basic), [1] * len(close)
line_up, line_down = [float("nan")] * len(close), [float("nan")] * len(close)
for i in range(1, len(close)):
    if upper_basic[i] < upper[i - 1] or close[i - 1] > upper[i - 1]:
        upper[i] = upper_basic[i]
    else:
        upper[i] = upper[i - 1]
    if lower_basic[i] > lower[i - 1] or close[i - 1] < lower[i - 1]:
        lower[i] = lower_basic[i]
    else:
        lower[i] = lower[i - 1]
    if trend[i - 1] == 1 and close[i] < lower[i]:
        trend[i] = -1
    elif trend[i - 1] == -1 and close[i] > upper[i]:
        trend[i] = 1
    else:
        trend[i] = trend[i - 1]
    if trend[i] == 1:
        line_up[i] = lower[i]
    else:
        line_down[i] = upper[i]

plot("Supertrend up", line_up, color="#4f94db")
plot("Supertrend down", line_down, color="#db8352")
print("Trend now:", "UP" if trend[-1] == 1 else "DOWN")
`,
  },
  {
    id: "s01_sma_cross",
    name: "SMA crossover",
    kind: "strategy",
    description: "Long when fast SMA is above slow SMA",
    code: String.raw`# Strategy: SMA crossover. Long when the fast average is above the slow one, flat otherwise.
import pandas as pd

FAST = 20     # <- change these numbers and press Run again
SLOW = 50

df = pd.DataFrame(candles)
fast = df["close"].rolling(FAST).mean()
slow = df["close"].rolling(SLOW).mean()
position = (fast > slow).astype(int)          # 1 = long, 0 = flat

plot("SMA %d" % FAST, fast, color="#e3c46a")
plot("SMA %d" % SLOW, slow, color="#a497e6")
signals(entries=position.diff() == 1, exits=position.diff() == -1)
backtest_stats(df["close"], position)
`,
  },
  {
    id: "s02_rsi_reversion",
    name: "RSI mean reversion",
    kind: "strategy",
    description: "Buy oversold, sell on recovery",
    code: String.raw`# Strategy: RSI mean reversion. Buy when RSI drops below LOW, sell when it climbs back above EXIT.
import pandas as pd

PERIOD = 14
LOW = 30      # buy below this
EXIT = 55     # sell above this

df = pd.DataFrame(candles)
change = df["close"].diff()
gain = change.clip(lower=0).ewm(alpha=1 / PERIOD, adjust=False).mean()
loss = (-change.clip(upper=0)).ewm(alpha=1 / PERIOD, adjust=False).mean()
rsi = 100 - 100 / (1 + gain / loss)

position, holding = [], 0
for value in rsi.tolist():
    if holding == 0 and value < LOW:
        holding = 1
    elif holding == 1 and value > EXIT:
        holding = 0
    position.append(holding)
position = pd.Series(position)

plot("RSI %d" % PERIOD, rsi, pane="oscillator", color="#6fbfb3")
plot("Buy level", [LOW] * len(df), pane="oscillator", color="#4f94db")
plot("Exit level", [EXIT] * len(df), pane="oscillator", color="#db8352")
signals(entries=position.diff() == 1, exits=position.diff() == -1)
backtest_stats(df["close"], position)
`,
  },
  {
    id: "s03_bollinger_reversion",
    name: "Bollinger mean reversion",
    kind: "strategy",
    description: "Buy below lower band, exit at middle",
    code: String.raw`# Strategy: Bollinger mean reversion. Buy when price closes below the lower band, sell when it returns to the middle line.
import pandas as pd

PERIOD = 20
WIDTH = 2.0

df = pd.DataFrame(candles)
mid = df["close"].rolling(PERIOD).mean()
std = df["close"].rolling(PERIOD).std()
upper, lower = mid + WIDTH * std, mid - WIDTH * std

position, holding = [], 0
for close, low_band, mid_line in zip(df["close"].tolist(), lower.tolist(), mid.tolist()):
    if holding == 0 and close < low_band:
        holding = 1
    elif holding == 1 and close >= mid_line:
        holding = 0
    position.append(holding)
position = pd.Series(position)

plot("BB upper", upper, color="#5d6a80")
plot("BB middle", mid, color="#7d8aa0")
plot("BB lower", lower, color="#5d6a80")
signals(entries=position.diff() == 1, exits=position.diff() == -1)
backtest_stats(df["close"], position)
`,
  },
  {
    id: "s04_macd_cross",
    name: "MACD crossover",
    kind: "strategy",
    description: "Long while MACD is above signal",
    code: String.raw`# Strategy: MACD crossover. Long while MACD is above its signal line.
import pandas as pd

FAST, SLOW, SIGNAL = 12, 26, 9

df = pd.DataFrame(candles)
macd = df["close"].ewm(span=FAST, adjust=False).mean() - df["close"].ewm(span=SLOW, adjust=False).mean()
signal_line = macd.ewm(span=SIGNAL, adjust=False).mean()
position = (macd > signal_line).astype(int)

plot("MACD", macd, pane="oscillator", color="#e3c46a")
plot("Signal", signal_line, pane="oscillator", color="#a497e6")
signals(entries=position.diff() == 1, exits=position.diff() == -1)
backtest_stats(df["close"], position)
`,
  },
  {
    id: "s05_donchian_breakout",
    name: "Donchian breakout",
    kind: "strategy",
    description: "Buy new highs, sell new lows",
    code: String.raw`# Strategy: Donchian breakout ("turtle"). Buy a new N-candle high, sell a new M-candle low.
import pandas as pd

ENTRY = 20
EXIT = 10

df = pd.DataFrame(candles)
entry_high = df["high"].rolling(ENTRY).max().shift(1)    # shift(1): compare with the PREVIOUS candles only
exit_low = df["low"].rolling(EXIT).min().shift(1)

position, holding = [], 0
for close, high_level, low_level in zip(df["close"].tolist(), entry_high.tolist(), exit_low.tolist()):
    if holding == 0 and close > high_level:       # NaN compares False, so nothing happens during warm-up
        holding = 1
    elif holding == 1 and close < low_level:
        holding = 0
    position.append(holding)
position = pd.Series(position)

plot("Entry level", entry_high, color="#4f94db")
plot("Exit level", exit_low, color="#db8352")
signals(entries=position.diff() == 1, exits=position.diff() == -1)
backtest_stats(df["close"], position)
`,
  },
  {
    id: "s06_supertrend_flip",
    name: "Supertrend flip",
    kind: "strategy",
    description: "Long while the trend is up",
    code: String.raw`# Strategy: Supertrend flip. Long while the trend is up, flat while it is down.
import pandas as pd

PERIOD = 10
MULTIPLIER = 3.0

df = pd.DataFrame(candles)
prev_close = df["close"].shift(1)
true_range = pd.concat([df["high"] - df["low"], (df["high"] - prev_close).abs(), (df["low"] - prev_close).abs()], axis=1).max(axis=1)
atr = true_range.ewm(alpha=1 / PERIOD, adjust=False).mean()
mid = (df["high"] + df["low"]) / 2
upper_basic = (mid + MULTIPLIER * atr).tolist()
lower_basic = (mid - MULTIPLIER * atr).tolist()
close = df["close"].tolist()

upper, lower, trend = list(upper_basic), list(lower_basic), [1] * len(close)
line = [float("nan")] * len(close)
for i in range(1, len(close)):
    upper[i] = upper_basic[i] if (upper_basic[i] < upper[i - 1] or close[i - 1] > upper[i - 1]) else upper[i - 1]
    lower[i] = lower_basic[i] if (lower_basic[i] > lower[i - 1] or close[i - 1] < lower[i - 1]) else lower[i - 1]
    if trend[i - 1] == 1 and close[i] < lower[i]:
        trend[i] = -1
    elif trend[i - 1] == -1 and close[i] > upper[i]:
        trend[i] = 1
    else:
        trend[i] = trend[i - 1]
    line[i] = lower[i] if trend[i] == 1 else upper[i]

position = pd.Series([1 if t == 1 else 0 for t in trend])
plot("Supertrend", line, color="#e3c46a")
signals(entries=position.diff() == 1, exits=position.diff() == -1)
backtest_stats(df["close"], position)
`,
  },
];
